import { render } from "./EditTypeConsultation.vue?vue&type=template&id=e7206e38&scoped=true"
import script from "./EditTypeConsultation.vue?vue&type=script&lang=js"
export * from "./EditTypeConsultation.vue?vue&type=script&lang=js"

import "./EditTypeConsultation.vue?vue&type=style&index=0&id=e7206e38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7206e38"]])

export default __exports__